import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { LeaderboardService, SellerService } from 'src/app/core';

@Component({
  selector: 'app-activity-challenge-documents',
  templateUrl: './activity-challenge-documents.component.html',
  styleUrls: ['./activity-challenge-documents.component.scss']
})
export class ActivityChallengeDocumentsComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ActivityChallengeDocumentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data, private sellerService: SellerService,
    private leaderboardService:LeaderboardService,
    @Inject(DOCUMENT) private document: Document) { }

  uploadFileCategoryList: any = [
    {
    label: 'Terms And Conditions',
    value: 'TERMS_AND_CONDITIONS',
    fileData: '',
    fileUploadSuccess: false
  }, {
    label: 'Others',
    value: 'OTHERS',
    fileData: '',
    fileUploadSuccess: false
  }]
  errorMessage: any = ''

  ngOnInit() {
    this.loadCiscoStyles('client-cisco.css');
  }

  OnClosePopup() {
    this.dialogRef.close({ refreshData: true });
  }

  downloadFile(category) {
    let fileUrl;
 
      fileUrl = this.data.fileData.attachments.filter(att => att.category === category.value)[0].url;
    
    
    window.open(fileUrl, '_blank').focus();
  }

  downloadTermsFile(fileUrl) {
    window.open(fileUrl, '_blank').focus();
  }

  compareFn(o1: any, o2: any) {
    if (o1.id == o2.id) return true;
  }

  getFileName(category) {
   
  
      return this.data.fileData.attachments.filter(att => att.category === category.value).length > 0 ? this.data.fileData.attachments.filter(att => att.category === category.value)[0].name : ''
    

  }

  getFile(eve, category) {
    category.fileData = eve.target.files[0];
  }

  uploadFile(fileData, category) {

    const uploadData = new FormData();
    uploadData.append('file-to-be-uploaded', fileData);

  
    if(this.data.path=='leaderboard'){
      let reqParams='?leaderboardChallengeId='+this.data.fileData.id+"&fileName="+fileData.name+'&category='+category.value;

      this.leaderboardService.uploadLeaderboardChgDocuments(uploadData,reqParams).subscribe((res)=>{
        if(res){
          category.fileUploadSuccess = true; 
          this.updateFilename(res,category)
        }
      }, (error) => {
        if(error.status==500){
          this.errorMessage = 'Something went wrong';
        } else {
          this.errorMessage = error.message
        }
    })
    }else{
      const challengeId = this.data.fileData.id;
      const params = '?activityChallengeId='+challengeId+"&fileName="+fileData.name+'&category='+category.value;

      this.sellerService.uploadActivityChallengeDocuments(uploadData, params).subscribe((response)=>{
        if(response){
          category.fileUploadSuccess = true;
          this.updateFilename(response,category)
        }
      }, (error) => {
          if(error.status==500){
            this.errorMessage = 'Something went wrong';
          } else {
            this.errorMessage = error.message
          }
      })
    }

  }
  updateFilename(res,category){
    if(this.data.fileData.attachments.length==0){
      if(category.value==res.category){
        this.data.fileData.attachments.push(res);
      }
      
      this.data.fileData.attachments.filter(att => att.category === category.value)
    }else {
  
      let testdata= this.data.fileData.attachments.filter(att => att.category === category.value);
      
      if(testdata.length==0){
        this.data.fileData.attachments.push(res); 
      }else{
        const index=this.data.fileData.attachments.findIndex((ele)=>ele.category===category.value);
        if(index!==-1){
          this.data.fileData.attachments.splice(index,1,res)
        }
      
      }
  
    }
  }
  loadCiscoStyles(styleName) {
    const head = this.document.getElementsByTagName('head')[0];
    const styleLink = this.document.createElement('link');
    styleLink.rel = 'stylesheet';
    styleLink.classList.add('cisco_styles')
    styleLink.href = styleName;
    head.appendChild(styleLink);
  };
}
